import type {
  DynamicQuestionAnswerValue,
  DynamicQuestionData,
  DynamicQuestionOption,
} from './types';

export const DYNAMIC_QUESTION_FILE_UPLOAD_LABEL_IDLE = `
<div>
  <div class="dynamic-question-file-upload-icon" aria-hidden="true"><i class="uil uil-upload"></i></div>
  <p>Drag and drop files here or <span class="filepond--label-action">Browse files</span></p>
  <p class="dynamic-question-file-upload-hint">File size limit: 100MB</p>
</div>
`.trim();

export interface DynamicQuestionProps {
  question: DynamicQuestionData;
  value: DynamicQuestionAnswerValue;
  onChange: (value: DynamicQuestionAnswerValue) => void;
  fileUploadHelpArticleUrl?: string;
  reportIdForEvidenceUpload?: string | null;
  reportIdForFileDownload?: string | null;
  fileDownloadCaseManagerView?: boolean;
  readOnly?: boolean;
  showValidation?: boolean;
  onRegisterQuestionnaireAttachment?: (input: {
    questionId: string;
    evidenceS3Path: string;
  }) => Promise<string | undefined>;
  onDeleteQuestionnaireAttachment?: (
    input: { attachmentId: string; questionId: string },
    options?: { onError?: (error: unknown) => void },
  ) => Promise<void>;
  'data-testid'?: string;
  isFlagged?: boolean | null;
}
export const sortOptions = (
  options: DynamicQuestionOption[],
): DynamicQuestionOption[] =>
  [...options].sort((a, b) => (a.optionOrder ?? 0) - (b.optionOrder ?? 0));
export const COI_EMPLOYEE_DIRECTORY_SUBTYPE_KEYS = ['employee_directory'];
export const DATABASE_EMPLOYEE_DIRECTORY_FIELDS = [
  'named_offender',
  'witness',
  ...COI_EMPLOYEE_DIRECTORY_SUBTYPE_KEYS,
];

export const FILEPOND_PROCESSING_COMPLETE = 5;
